import React, { ReactElement } from "react";
import MainImg from "./mainImg";

import SharedButton from "../sharedButton";
export default function WhoIsHomeWarranty(): ReactElement {
    return (
        <section className="flex flex-col lg:flex-row lg:gap-28 gap-16  lg:mt-28 mt-14 lg:mb-52 mb-28 ">
            <div className="max-w-[574px]  mx-auto lg:mx-0 ">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    Who Is a Home Warranty For?
                </h2>
                <p className="mt-5   lg:text-lg text-base lg:leading-8  font-light">
                    A home warranty is a great solution for homeowners looking
                    to protect their appliances and systems from unforeseen
                    breakdowns and costly repairs. It's especially beneficial
                    for individuals who may not have the skills or time to
                    handle maintenance tasks. By providing coverage for home
                    systems, a home warranty offers homeowners peace of mind in
                    the event of unexpected breakdowns.
                </p>
                <div className="lg:mt-[50px] mt-7 text-center sm:text-left">
                    <SharedButton />
                </div>
                <span className="w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"></span>
            </div>
            <div className="w-[300px] h-[250px] md:h-[434px] md:w-[437px] md:min-w-[437px] relative mx-auto lg:mx-0 lg:mt-4">
                <MainImg />
            </div>
        </section>
    );
}
